<template>
  <carousel-post-form
    :form="form"
    :image-url="null"
    :site-context-options="site_context_options"
    class="w-full bg-white"
    @submit="submit"
  >
    <div
      class="flex items-center justify-end border-t border-gray-200 bg-gray-100 px-6 py-4"
    >
      <loading-button
        :loading="form.processing"
        class="btn-indigo"
        type="submit"
      >
        Utwórz post karuzeli
      </loading-button>
    </div>
  </carousel-post-form>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import { useForm } from '@inertiajs/vue3';
import LoadingButton from '@/Shared/LoadingButton.vue';
import CarouselPostForm from './Form.vue';
import { createCarouselPostRouteHelper } from '@/utils/createCarouselPostRouteHelper';

const { proxy } = getCurrentInstance();
const routes = proxy.$routes;

defineProps({
  // eslint-disable-next-line vue/prop-name-casing
  site_context_options: {
    type: Array,
    default: () => [],
  },
});

const emptyLocale = () => ({ title: '', description: '', button_text: '' });

const form = useForm({
  carousel_post: {
    data_pl: emptyLocale(),
    data_en: emptyLocale(),
    button_url: '',
    button_link_label: '',
    button_link_type_label: '',
    show_button: true,
    site_context: 'code_medical_center',
    active: true,
    image: null,
  },
});

const carouselPostRoutes = computed(() => createCarouselPostRouteHelper(null, routes));

const emit = defineEmits(['success']);

const submit = () => {
  form.post(carouselPostRoutes.value.index(), {
    onFinish: () => {
      if (!form.hasErrors) {
        form.reset();
        form.carousel_post.data_pl = emptyLocale();
        form.carousel_post.data_en = emptyLocale();
        form.carousel_post.site_context = 'code_medical_center';
        form.carousel_post.active = true;
        form.carousel_post.show_button = true;
      }
    },
    onSuccess: () => {
      emit('success');
    },
    onError: () => {},
  });
};
</script>
